<script setup>
defineProps({
  size: {
    type: Number,
    required: true,
  },
  className: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'orange',
  },
  fill: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <div
    :style="{ width: `${size}px`, height: `${size}px`, backgroundColor: fill ? color : 'inherit' }"
    :class="[className ? `${className} ${color} dot` : `${color} dot`]"
  />
</template>

<style lang="scss" scoped>
.dot {
  position: absolute;
  width: fit-content;
  border-radius: 50%;
  box-sizing: content-box;

  &.aqua {
    border: wds-rem(2px) solid $wds-color-teal-lighter;
    background-color: $wds-color-teal-lighter;
  }

  &.green {
    border: wds-rem(2px) solid $wds-color-green-light;
    background-color: $wds-color-green-light;
  }

  &.blue {
    border: wds-rem(2px) solid $wds-color-blue-light;
    background-color: $wds-color-blue-light;
  }

  &.violet {
    border: wds-rem(2px) solid $wds-color-purple-light;
    background-color: $wds-color-purple-light;
  }

  &.pink {
    border: wds-rem(2px) solid $wds-color-red-light;
    background-color: $wds-color-red-light;
  }

  &.yellow {
    border: wds-rem(2px) solid $wds-color-yellow-lighter;
    background-color: $wds-color-yellow-lighter;
  }

  &.orange {
    background-color: $wds-color-sunset-light;
  }

  &.red {
    background-color: $wds-color-red-lighter;
  }
}
</style>
